class MultistepQuotation {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-multistep-quotation="scope"]',
			products: '[data-multistep-quotation="products"]',
			nextStep: '[data-multistep-quotation="next-step"]',
			removeProductButton: '[data-multistep-quotation="remove-product"]',
			roomsForm: '[data-multistep-quotation="rooms-form"]',
			rooms: '[data-multistep-quotation="rooms"]',
			roomTitle: '[data-multistep-quotation="room-title"]',
			addRoomButton: '[data-multistep-quotation="add-room"]',
			multipleRooms: '[name="multiple_rooms"]',
			roomOption: '[data-multistep-quotation="room-option"]',
			toast: '[data-scope="toast"]',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.on('click', this.config.removeProductButton, this.handleRemoveProduct.bind(this));
		this.$scope.on('click', this.config.addRoomButton, this.handleAddRoom.bind(this));
		this.$scope.on('keydown', this.config.roomTitle, this.handleRoomTitleKeydown.bind(this));
		this.$scope.on('change', this.config.multipleRooms, this.handleMultipleRoomsChange.bind(this));
		this.$scope.on('change', this.config.roomOption, this.handleRoomOptionChange.bind(this));
	}

	isSingleRoom() {
		return this.$scope.find(this.config.multipleRooms).filter(':checked').val() === '0';
	}

	handleMultipleRoomsChange() {
		let single = this.isSingleRoom();
		let $options = this.$scope.find(this.config.roomOption);

		$options.each((index, element) => element.type = single ? 'radio' : 'checkbox');

		if (single) {
			$options.filter(':checked').slice(1).prop('checked', false);
		}
	}

	// De radio's hebben verschillende namen (rooms[] en custom_rooms[]), dus de browser sluit ze niet zelf uit.
	handleRoomOptionChange(event) {
		if (!this.isSingleRoom() || !event.currentTarget.checked) {
			return;
		}

		this.$scope.find(this.config.roomOption).not(event.currentTarget).prop('checked', false);
	}

	// Enter in het invoerveld moet de ruimte toevoegen, niet het formulier naar de volgende stap sturen.
	handleRoomTitleKeydown(event) {
		if (event.which !== 13) {
			return;
		}

		event.preventDefault();
		this.$scope.find(this.config.addRoomButton).trigger('click');
	}

	handleAddRoom(event) {
		event.preventDefault();
		let $button = $(event.currentTarget);
		let $form = this.$scope.find(this.config.roomsForm);
		let $title = this.$scope.find(this.config.roomTitle);
		let title = $title.val().trim();

		if (title === '') {
			$title.trigger('focus');
			return;
		}

		let data = $form.serializeArray().filter(field => field.name !== 'action');
		data.push({name: 'action', value: 'add_room'});
		data.push({name: 'room_title', value: title});

		$button.prop('disabled', true);

		$.ajax({
			url: this.$scope.data('route'),
			method: 'POST',
			data: $.param(data),
			success: (response) => {
				this.onRoomsChanged(response);
				$title.val('').trigger('focus');
			},
			error: this.onError.bind(this),
			complete: () => $button.prop('disabled', false),
		});
	}

	onRoomsChanged(response) {
		if (response.rooms !== undefined) {
			this.$scope.find(this.config.rooms).html(response.rooms);
		}

		this.showMessage(response.message);
	}

	handleRemoveProduct(event) {
		event.preventDefault();
		let $button = $(event.currentTarget);

		if ($button.data('confirm') && !confirm($button.data('confirm'))) {
			return;
		}

		$button.prop('disabled', true);

		$.ajax({
			url: this.$scope.data('route'),
			method: 'POST',
			data: {
				action: 'remove_product',
				product_id: $button.data('product-id'),
			},
			success: this.onProductsChanged.bind(this),
			error: this.onError.bind(this),
			complete: () => $button.prop('disabled', false),
		});
	}

	onProductsChanged(response) {
		if (response.products !== undefined) {
			this.$scope.find(this.config.products).html(response.products);
		}

		if (response.next_step !== undefined) {
			this.$scope.find(this.config.nextStep).html(response.next_step);
		}

		this.showMessage(response.message);
	}

	onError(response) {
		alert(response.responseJSON?.message || 'Er is iets fout gegaan.');
	}

	showMessage(message) {
		if (!message) {
			return;
		}

		let $toast = $(this.config.toast);
		let $content = $toast.find('[data-scope="content"]');
		$content.html(message);

		let toastEl = $toast.get(0);
		if (!toastEl) {
			return;
		}

		new bootstrap.Toast(toastEl).show();
		toastEl.addEventListener('hidden.bs.toast', () => $content.html(''), {once: true});
	}
}

export default MultistepQuotation;
